import { ISelectItem } from '@lla-platform/core/core-ui'

export enum InvoiceOperatedType {
  NotOperatedByLLA = 'NotOperatedByLLA',
  OperatedByLLA = 'OperatedByLLA'
}

export const InvoiceOperatedTypeToLabel: { [key: string]: string } = {
  NotOperatedByLLA: 'Not Operated by LLA',
  OperatedByLLA: 'Operated by LLA'
}

export const InvoiceOperatedTypeItems: ISelectItem[] = [
  {
    label: InvoiceOperatedTypeToLabel[InvoiceOperatedType.OperatedByLLA],
    value: InvoiceOperatedType.OperatedByLLA
  },
  {
    label: InvoiceOperatedTypeToLabel[InvoiceOperatedType.NotOperatedByLLA],
    value: InvoiceOperatedType.NotOperatedByLLA
  }
]
